"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickUpdate = void 0;
class ClickUpdate {
    constructor(position, username) {
        this.position = position;
        this.username = username;
    }
}
exports.ClickUpdate = ClickUpdate;
//# sourceMappingURL=ClickUpdate.js.map